import { Routes, Route, Navigate } from 'react-router-dom'
import { WalletProvider } from './providers/WalletProvider'
import { AuthProvider } from './providers/AuthProvider'
import { AdminLayout } from './components/layout/AdminLayout'
import { UserLayout } from './components/layout/UserLayout'
import { ConnectWallet } from './pages/ConnectWallet'
import Login from './pages/Login'
import Register from './pages/Register'
import UserDashboard from './pages/UserDashboard'
import Settlements from './pages/Settlements'
import { Tokens } from './pages/Tokens'
import { Governance } from './pages/Governance'
import { Analytics } from './pages/Analytics'
import { Marketplace } from './pages/Marketplace'
import CompanyInfo from './pages/CompanyInfo'
import AdminDashboard from './pages/admin/AdminDashboard'
import AdminSettlements from './pages/admin/AdminSettlements'
import AdminSwap from './pages/admin/AdminSwap'
import AdminTokenFactory from './pages/admin/AdminTokenFactory'
import AdminGovernance from './pages/admin/AdminGovernance'
import AdminAnalytics from './pages/admin/AdminAnalytics'
import AdminInfo from './pages/admin/AdminInfo'
import AdminApiKeys from './pages/admin/AdminApiKeys'
import ApiKeys from './pages/ApiKeys'
import ApiDocumentation from './pages/ApiDocumentation'
import TokenFactory from './pages/TokenFactory'
import TransactionHistoryPDFPage from './pages/TransactionHistoryPDFPage'
import ProtectedRoute from './components/ProtectedRoute'
import PublicRoute from './components/PublicRoute'
import { DemoAccessTermsModal, useDemoAccessTerms } from './components/DemoAccessTermsModal'

function App() {
  const { showTerms, acceptTerms } = useDemoAccessTerms()

  return (
    <AuthProvider>
      <WalletProvider>
        {/* Demo Access Terms Modal */}
        {showTerms && <DemoAccessTermsModal onAccept={acceptTerms} />}
        
        <Routes>
          {/* Public routes - redirect to dashboard if authenticated */}
          <Route path="/login" element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          } />
          <Route path="/register" element={
            <PublicRoute>
              <Register />
            </PublicRoute>
          } />
          
          {/* User routes with UserLayout */}
          <Route path="/dashboard" element={
            <ProtectedRoute>
              <UserLayout />
            </ProtectedRoute>
          }>
            <Route index element={<UserDashboard />} />
          </Route>
          
          <Route path="/settlements" element={
            <ProtectedRoute>
              <UserLayout />
            </ProtectedRoute>
          }>
            <Route index element={<Settlements />} />
          </Route>
          
          <Route path="/tokens" element={
            <ProtectedRoute>
              <UserLayout />
            </ProtectedRoute>
          }>
            <Route index element={<Tokens />} />
          </Route>
          
          <Route path="/governance" element={
            <ProtectedRoute>
              <UserLayout />
            </ProtectedRoute>
          }>
            <Route index element={<Governance />} />
          </Route>
          
          <Route path="/analytics" element={
            <ProtectedRoute>
              <UserLayout />
            </ProtectedRoute>
          }>
            <Route index element={<Analytics />} />
          </Route>
          
          <Route path="/marketplace" element={
            <ProtectedRoute>
              <UserLayout />
            </ProtectedRoute>
          }>
            <Route index element={<Marketplace />} />
          </Route>
          
          <Route path="/company-info" element={
            <ProtectedRoute>
              <UserLayout />
            </ProtectedRoute>
          }>
            <Route index element={<CompanyInfo />} />
          </Route>
          
          <Route path="/api-keys" element={
            <ProtectedRoute>
              <UserLayout />
            </ProtectedRoute>
          }>
            <Route index element={<ApiKeys />} />
          </Route>
          
          <Route path="/api-documentation" element={
            <ProtectedRoute>
              <UserLayout />
            </ProtectedRoute>
          }>
            <Route index element={<ApiDocumentation />} />
          </Route>
          
          <Route path="/token-factory" element={
            <ProtectedRoute>
              <UserLayout />
            </ProtectedRoute>
          }>
            <Route index element={<TokenFactory />} />
          </Route>
          
          {/* Admin routes with AdminLayout */}
          <Route path="/admin" element={
            <ProtectedRoute requireAdmin={true}>
              <AdminLayout />
            </ProtectedRoute>
          }>
            <Route index element={<AdminDashboard />} />
            <Route path="settlements" element={<AdminSettlements />} />
            <Route path="swap" element={<AdminSwap />} />
            <Route path="token-factory" element={<AdminTokenFactory />} />
            <Route path="governance" element={<AdminGovernance />} />
            <Route path="analytics" element={<AdminAnalytics />} />
            <Route path="api-documentation" element={<ApiDocumentation />} />
            <Route path="api-keys" element={<AdminApiKeys />} />
            <Route path="info" element={<AdminInfo />} />
          </Route>
          
          <Route path="/connect" element={
            <ProtectedRoute>
              <ConnectWallet />
            </ProtectedRoute>
          } />
          
          {/* PDF route - no authentication required */}
          <Route path="/pdf/transaction-history" element={<TransactionHistoryPDFPage />} />
          
          {/* Legacy routes - redirect to appropriate dashboard */}
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="/admin/dashboard" element={<Navigate to="/admin" replace />} />
          <Route path="/settlements" element={<Navigate to="/dashboard" replace />} />
          <Route path="/tokens" element={<Navigate to="/dashboard" replace />} />
          <Route path="/governance" element={<Navigate to="/dashboard" replace />} />
          <Route path="/analytics" element={<Navigate to="/dashboard" replace />} />
          <Route path="/marketplace" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </WalletProvider>
    </AuthProvider>
  )
}

export default App
